export const headlineTemplate = `
    <div class="pl_table-view--headline
                squirrel_searchSuggestions__headline
                js_squirrel_ignore_close_suggest">
        <span class="pl_copy75 js_squirrel_ignore_close_suggest">Suchvorschläge</span>
    </div>
`;

export const itemLabelTemplate = `
    <span data-suggestPos="{{suggestPos}}"
          data-target="{{target}}" 
          data-term="{{term}}"
          class="pl_copy100
                 squirrel_searchSuggest__term
                 js_squirrel_searchSuggest__term">
        {{{visual}}}
    </span>
`;

export const modifiedArrowTemplate = `
    <svg class="pl_icon100 squirrel_searchSuggest__right-icon js_squirrel_searchSuggest__arrow js_squirrel_ignore_close_suggest" role="img" data-qa-id="search-suggest-arrow">
        <use xlink:href="/assets-static/icons/pl_icon_search-enter.svg#pl_icon_search-enter"/>
    </svg>
`;

export const keywordsTemplate = `
    {{#keywords}}
    <li class="squirrel_searchSuggest"
        data-qa-id="search-suggest">
        <div class="pl_table-view--item-fully-clickable">
            <div class="squirrel_searchSuggest__text
                        js_squirrel_searchSuggest"
                 data-qa-id="search-suggest-text">
                {{>itemLabelTemplate}}
                {{>modifiedArrowTemplate}}
            </div>
        </div>
    </li>
    {{/keywords}}
`;
